<template>
	<div class="">
		<Tou></Tou>
		<div style="background-color: ;">
			<div class="activitybox">
				<div style="" class="pt-90 w1500">
					<div  class="flex j-between ">
						<div class="activitybox1" style="">
							<div class="f-56 montserBold activitybox1title" style="font-weight:700;width:100%;color:#111827;">
								{{gudingziduan.activity.toptitle}}
							</div>
							<div class="f-56 montserBold activitybox1title" style="font-weight:700;width:100%;color:#111827;">{{gudingziduan.activity.toptitlex}}</div>
							<div class="f-16 mt-9 montserRegular" style="color: #374151;">{{gudingziduan.activity.toptitle2}}</div>
							<div class="f-18 mt-49 mb-120 montserRegular" style="color: #374151;">{{gudingziduan.activity.toptitle3}}</div>
							<div @click="tiaozhuang" class="cur_pointer wow t-center ys-0 f-18 mb-52 more1" style="background: linear-gradient(108deg,#fc6148 3%, #e80e1a 100%);width:2.52rem;height:0.6rem;border-radius:0.6rem;line-height: 0.6rem;">{{gudingziduan.activity.topbtn}}</div>
							 <div class="cur_pointer pb-74 f-16" style="color:#959595;">{{gudingziduan.activity.topbtn2}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		 
		<div class="bj-0 pt-105 pb-168" style="width:100%;">
			<div class="w1500">
				<div class="B-700 f-42 t-center montserBold" style="">
				{{gudingziduan.activity.Whattoptitle}}
				</div>
				<div class="B-700 f-42 t-center mb-48 montserBold">{{gudingziduan.activity.Whattoptitle2}}</div>
				<div class="flex j-between Whattopbox">
					<div class="t-center a-center flex flex-wrap j-center Whattopboxlies">
						<div style="width:100%">
							<el-image fit="contain" class="mr-7"  style="whith:1.37rem;height:1.37rem"  :src="require('@/assets/pc/activtion/w1.png')" alt="" />
						</div>
						<div class="f-24 mt-53 f-bold mb-27 " style="color:#111827;">{{gudingziduan.activity.Validatetitle}}</div>
						<div class="f-16" style="color:#374151;">{{gudingziduan.activity.Validateneirong}}</div>
					</div>
					<div class="t-center a-center flex flex-wrap j-center Whattopboxlies" >
						<div style="width:100%">
							<el-image fit="contain" class="mr-7"  style="whith:1.37rem;height:1.37rem"  :src="require('@/assets/pc/activtion/w2.png')" alt="" />
						</div>
						<div class="f-24 mt-53 f-bold mb-27" style="color:#111827;">{{gudingziduan.activity.Validatetitle2}}</div>
						<div class="f-16" style="color:#374151;">{{gudingziduan.activity.Validateneirong2}}</div>
					</div>
					<div class="t-center a-center flex flex-wrap j-center Whattopboxlies" >
						<div style="width:100%">
							<el-image fit="contain" class="mr-7"  style="whith:1.37rem;height:1.37rem"  :src="require('@/assets/pc/activtion/w3.png')" alt="" />
						</div>
						<div class="f-24 mt-53 f-bold mb-27" style="color:#111827;">{{gudingziduan.activity.Validatetitle3}}</div>
						<div class="f-16" style="color:#374151;">{{gudingziduan.activity.Validateneirong3}}</div>
					</div>
				</div>
			</div>
		</div>
		<div class=" pt-95 pb-37" style="width:100%;background: #F4F4F4;">
			<div class="w1500">
				<div class="B-700 f-42 t-center  montserBold" style="">
					{{gudingziduan.activity.CERTIFICATIONtop}}
				</div>
				<div class="flex j-between mt-129 CERTIFICATIONbox" style="width:100%;">
					<div class="CERTIFICATIONbox_list">
						<div style="width:100%;">
							<div class="activeshubiao2">
								<div class="activeshubiao">1</div>
								<el-image fit="contain" class="activeshubiao2_tu"  style="whith:0.64rem;height:0.64rem"  :src="require('@/assets/pc/activtion/cerit1.png')" alt="" />
							</div>
						</div>
						<div class="t-center f-24 f-bold mt-39 mb-29" style="color: #111827;">{{gudingziduan.activity.CERTItitle}}</div>
						<div class="t-center f-16" style="color: #374151;">{{gudingziduan.activity.CERTIneirong}}</div>
					</div>
					<el-image fit="contain" class="mt-116 CERTIFICATIONbox_listtu" style="whith:0.44rem;height:0.44rem"  :src="require('@/assets/pc/activtion/fanhuiu.png')" alt="" />
					<div  class="CERTIFICATIONbox_list">
						<div style="width:100%;">
							<div class="activeshubiao2">
								<div class="activeshubiao">2</div>
								<el-image fit="contain" class="activeshubiao2_tu"  style="whith:0.54rem;height:0.54rem"  :src="require('@/assets/pc/activtion/cerit2.png')" alt="" />
							</div>
						</div>
						<div class="t-center f-24 f-bold mt-39 mb-29" style="color: #111827;">{{gudingziduan.activity.CERTItitle2}}</div>
						<div class="t-center f-16" style="color: #374151;">{{gudingziduan.activity.CERTIneirong2}}</div>
					</div>
					<el-image fit="contain" class="mt-116 CERTIFICATIONbox_listtu" style="whith:0.44rem;height:0.44rem"  :src="require('@/assets/pc/activtion/fanhuiu.png')" alt="" />
					 <div  class="CERTIFICATIONbox_list">
					 	<div style="width:100%;">
					 		<div class="activeshubiao2">
								<div class="activeshubiao">3</div>
					 			<el-image fit="contain" class="activeshubiao2_tu"  style="whith:0.48rem;height:0.48rem"  :src="require('@/assets/pc/activtion/cerit3.png')" alt="" />
					 		</div>
					 	</div>
					 	<div class="t-center f-24 f-bold mt-39 mb-29" style="color: #111827;">{{gudingziduan.activity.CERTItitle3}}</div>
					 	<div class="t-center f-16" style="color: #374151;">{{gudingziduan.activity.CERTIneirong3}}</div>
					 </div> 
					 <el-image fit="contain" class="mt-116 CERTIFICATIONbox_listtu" style="whith:0.44rem;height:0.44rem"  :src="require('@/assets/pc/activtion/fanhuiu.png')" alt="" />
					 <div class="CERTIFICATIONbox_list">
					 	<div style="width:100%;">
					 		<div class="activeshubiao2">
								<div class="activeshubiao">4</div>
					 			<el-image fit="contain" class="activeshubiao2_tu"  style="whith:0.66rem;height:0.66rem"  :src="require('@/assets/pc/activtion/cerit4.png')" alt="" />
					 		</div>
					 	</div>
					 	<div class="t-center f-24 f-bold mt-39 mb-29" style="color: #111827;">{{gudingziduan.activity.CERTItitle4}}</div>
					 	<div class="t-center f-16" style="color: #374151;">{{gudingziduan.activity.CERTIneirong4x}}</div>
					 </div> 
				</div>
				<div class="f-16 " style="color:#A7A7A7;margin-top: 2.7rem;">{{gudingziduan.activity.CERTItitle5}}</div>
				<div class="f-16 " style="color:#A7A7A7">{{gudingziduan.activity.CERTItitle6}}</div>
			</div>
		</div>
		<div class=" pt-112 pb-102" style="width:100%;background: #fff;position: relative;">
			<div class="w1500">
				<div class="flex j-between w100s SERVICEbox" >
					<div style="" class="SERVICEboxlist">
						<div  class="f-42 B-700 montserBold">{{gudingziduan.activity.SERVICEtitle}}</div>
						<div class="f-42  B-700 montserBold">{{gudingziduan.activity.SERVICEtitlexx}}</div>
						<div class="f-18 mb-45">{{gudingziduan.activity.SERVICEtitle2}}</div>
						<div >
							<div class="flex a-center mb-30">
								<div class="hongyuans mr-24"></div>
								<div class="f-18" style="color: #3D3D3D;">{{gudingziduan.activity.SERVICEtitlex}}</div>
							</div>
							<div class="flex a-center mb-30">
								<div class="hongyuans mr-24"></div>
								<div class="f-18" style="color: #3D3D3D;">{{gudingziduan.activity.SERVICEtitlex2}}</div>
							</div>
							<div class="flex a-center mb-30">
								<div class="hongyuans mr-24"></div>
								<div class="f-18" style="color: #3D3D3D;">{{gudingziduan.activity.SERVICEtitlex3}}</div>
							</div>
							<div class="flex a-center mb-30">
								<div class="hongyuans mr-24"></div>
								<div class="f-18" style="color: #3D3D3D;">{{gudingziduan.activity.SERVICEtitlex4}}</div>
							</div>
							<div class="flex a-center mb-30">
								<div class="hongyuans mr-24"></div>
								<div class="f-18" style="color: #3D3D3D;">{{gudingziduan.activity.SERVICEtitlex5}}</div>
							</div>
							<div class="flex a-center mb-30">
								<div class="hongyuans mr-24"></div>
								<div class="f-18" style="color: #3D3D3D;">{{gudingziduan.activity.SERVICEtitlex6}}</div>
							</div>
						</div>
					</div>
					<el-image fit="contain" class="mt-116 SERVICEboxlisttu" style=""  :src="require('@/assets/pc/activtion/server1.png')" alt="" />
				</div>
			</div>
		</div>
		<div class=" pt-126 pb-101" style="width:100%;background: #F4F4F4;">
			<div class="w1500">
				<div  class="f-42 f-bold t-center">{{gudingziduan.activity.Questionstoptitle}}</div>
				<div class="Questionstopbox mt-62 pt-42 pb-42">
					<div style="width:78%;" class="ml-67">
						<div class="Questionstopbox_list pb-16">
							<div class="flex a-center ">
								<div class="el-icon-question mr-8" style="color: #EF4444;"></div>
								<div class="f-22 B-600" style="color:#111827;">{{gudingziduan.activity.Questionsquestions}}</div>
							</div>
							<div class="f-16 B-400 ml-24 mt-8" style="color:#374151;">{{gudingziduan.activity.Questionshuida}}</div>
						</div>
						<div class="Questionstopbox_list pt-16 pb-16">
							<div class="flex a-center ">
								<div class="el-icon-question mr-8" style="color: #EF4444;"></div>
								<div class="f-22 B-600" style="color:#111827;">{{gudingziduan.activity.Questionsquestions1}}</div>
							</div>
							<div class="f-16 B-400 ml-24 mt-8" style="color:#374151;">{{gudingziduan.activity.Questionshuida1}}</div>
						</div>
						<div class="Questionstopbox_list pt-16 pb-16">
							<div class="flex a-center">
								<div class="el-icon-question mr-8" style="color: #EF4444;"></div>
								<div class="f-22 B-600" style="color:#111827;">{{gudingziduan.activity.Questionsquestions2}}</div>
							</div>
							<div class="f-16 B-400 ml-24 mt-8" style="color:#374151;">{{gudingziduan.activity.Questionshuida2}}</div>
						</div>
						<div class="Questionstopbox_list pt-16 pb-16">
							<div class="flex a-center">
								<div class="el-icon-question mr-8" style="color: #EF4444;"></div>
								<div class="f-22 B-600" style="color:#111827;">{{gudingziduan.activity.Questionsquestions3}}</div>
							</div>
							<div class="f-16 B-400 ml-24 mt-8" style="color:#374151;">{{gudingziduan.activity.Questionshuida3}}</div>
						</div>
						<div class="Questionstopbox_list pt-16 pb-16">
							<div class="flex a-center">
								<div class="el-icon-question mr-8" style="color: #EF4444;"></div>
								<div class="f-22 B-600" style="color:#111827;">{{gudingziduan.activity.Questionsquestions4}}</div>
							</div>
							<div class="f-16 B-400 ml-24 mt-8" style="color:#374151;">{{gudingziduan.activity.Questionsquestions4}}</div>
						</div>
						<div class="Questionstopbox_list pt-16 pb-16">
							<div class="flex a-center">
								<div class="el-icon-question mr-8" style="color: #EF4444;"></div>
								<div class="f-22 B-600" style="color:#111827;">{{gudingziduan.activity.Questionsquestions5}}</div>
							</div>
							<div class="f-16 B-400 ml-24 mt-8" style="color:#374151;">{{gudingziduan.activity.Questionsquestions5}}</div>
						</div>
						<div class="Questionstopbox_list pt-16 pb-16">
							<div class="flex a-center">
								<div class="el-icon-question mr-8" style="color: #EF4444;"></div>
								<div class="f-22 B-600" style="color:#111827;">{{gudingziduan.activity.Questionsquestions6}}</div>
							</div>
							<div class="f-16 B-400 ml-24 mt-8" style="color:#374151;">{{gudingziduan.activity.Questionsquestions6}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class=" pt-125 pb-101" style="width:100%;background: linear-gradient( 114deg, #F05252 0%, #E60012 100%), rgba(0,0,0,0);">
			<div class="t-center ys-0 f-48 B-700 mb-4">{{gudingziduan.activity.Certifiedtitle}}</div>
			<div class="t-center  f-20" style="color:#FEE2E2">{{gudingziduan.activity.Certifiedtitle2}}</div>
			<div class="t-center f-20" style="color:#FEE2E2">{{gudingziduan.activity.Certifiedtitle2x}}</div>
			<div @click="tiaozhuang" class="Questionstopbox_listbtn cur_pointer t-center f-18 B-600 wow ">{{gudingziduan.activity.Certifiedtitle3}}</div>
			<div class=" t-center f-18 " style="color:#FEE2E2">{{gudingziduan.activity.Certifiedtitle4}}</div>
		</div> 
		<Foot></Foot>
	</div>
</template>

<script>
	import Tou from '../../../zuzuzu/touss.vue'
	import Foot from '../../../zuzuzu/foot.vue'
	import {Activitylist,Activityget} from '@/api/activity.js';
	export default {
		data() {
			return {
				gudingziduan: {},
				activityld:'',
				url:''
			}
		},
		components: { Tou, Foot},
		watch: {
		    '$store.state.cunyuanyan': {
		      handler(newValue, oldValue) {
		        this.gudingziduan=this.$store.state.cunyuanyan
		      },
		      deep: true // 如果 cunyuanyan 是对象，需要设置 deep 为 true
		    }
		},
		mounted() {
			new this.$wow.WOW({
				live: false
			}).init()
		},
		created() {
			Activitylist().then(s=>{
				this.activityld=s.data[0].id
				this.url=s.data[0].linkUrl
			})
			this.$store.commit('Gaiyuyan', this.$store.state.yuyan);
			this.gudingziduan=this.$store.state.cunyuanyan
			console.log(this.gudingziduan)
		},
		methods: {
			tiaozhuang(){
				Activityget({activityId:this.activityld}).then(s=>{
					if(s.result=='SUCCESS'){
						window.open(this.url, '_blank');
					}
				})
			}
		},
	}
</script>

<style>
	.learningbox{
	}
	.activitybox{
		width: 100%;
		background: url('../../../assets/pc/activtion/bg.png') no-repeat ;
		background-size: cover;
	}
	.activeshubiao{
		width:0.39rem;
		height: 0.39rem;
		background-color:#E60012;
		border-radius: 50%;
		text-align: center;
		line-height: 0.39rem;
		color: #fff;
		position: absolute;
		left: -0.61rem;
		top: 0;
	}
	.activeshubiao2{
		width:1.30rem;
		height: 1.30rem;
		background-color:#fff;
		border-radius: 50%;
		margin: 0 auto;
		text-align: center;
		line-height: 1.3rem;
		align-items: center;
		display: flex;
		position: relative;
	}
	.activeshubiao2_tu{
		margin: 0 auto 0 auto;
	}
	.hongyuans{
		width: 0.12rem;
		height: 0.12rem;
		background: #E60012;
		border-radius: 50%;
		min-width: 0.12rem;
	}
	.Questionstopbox{
		width:100%;
		background-color: #fff;
		border-radius: 0.26rem;
	}
	.Questionstopbox_list{
		width: 100%;
		border-bottom: 1px solid #E5E7EB;
	}
	.Questionstopbox_listbtn{
		width: 3.23rem;
		height: 0.60rem;
		border-radius: 0.6rem;
		margin: 0.34rem auto 0.34rem auto;
		background-color: #fff;
		line-height: 0.6rem;
		color: #EF4444;
	}
	.activitybox1{
		width: 54%;
	}
	.SERVICEboxlist{
		width:50%
	}
	.SERVICEboxlisttu{
		whith:9.18rem;height:5.58rem;position: absolute;right: 0;top: 0;
	}
	.Whattopboxlies{
		width:30%;
	}
	.CERTIFICATIONbox_list{
		width:20%;
	}
	@media screen and (max-width: 767px) {
		.activitybox1{
			width: 90%;
		}
		.activitybox1title{
			font-size: .46rem !important;
		}
		.SERVICEbox{
			display: inherit !important;
		}
		.SERVICEboxlist{
			width:100% !important;
		}
		.SERVICEboxlisttu{
			position:inherit  !important;
			margin-top: 0px;
		}
		.Whattopbox{
			display: inherit !important;
		}
		.Whattopboxlies{
			width:100%;
			margin-top: 20px;
		}
		.CERTIFICATIONbox{
			flex-wrap: wrap;
		}
		.CERTIFICATIONbox_list{
			width:50%;
			margin-bottom: 30px;
		}
		.CERTIFICATIONbox_listtu{
			display: none;
		}
	}
</style>